import { FC, ReactNode } from 'react'
import { FormLabel, FormHelperText, Box } from '@material-ui/core'
import { useFormControl } from '@material-ui/core/FormControl'
// @ts-ignore
import formControlState from '@material-ui/core/FormControl/formControlState'
import { FormHelperTextProps } from '@material-ui/core/FormHelperText'
import { FormLabelProps } from '@material-ui/core/FormLabel'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import RequiredLabelText from './RequiredLabelText'

const useStyle = makeStyles(() => ({
  requiredLabel: {
    '&::before': {
      content: 'none !important',
    },
  },
}))

export type LabelRequiredVariant = 'default' | 'text'

interface LabelWithHelperProps {
  helperText?: ReactNode
  label?: ReactNode
  labelRequiredVariant?: LabelRequiredVariant
  required?: boolean
  FormLabelProps?: FormLabelProps
  FormHelperTextProps?: FormHelperTextProps
}

const LabelWithHelper: FC<LabelWithHelperProps> = (props) => {
  const {
    helperText,
    label,
    labelRequiredVariant = 'default',
    FormLabelProps,
    FormHelperTextProps,
  } = props
  const classes = useStyle()
  const muiFormControl = useFormControl()
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['required'],
  })

  return (
    <>
      {(label || helperText) && (
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          {label && (
            <FormLabel
              error={false}
              focused={false}
              className={clsx({
                [classes.requiredLabel]: labelRequiredVariant === 'text',
              })}
              {...FormLabelProps}
            >
              {label}
              {labelRequiredVariant === 'text' && fcs.required && (
                <RequiredLabelText />
              )}
            </FormLabel>
          )}
          {helperText && !label && <div />}
          {helperText && (
            <FormHelperText {...FormHelperTextProps}>
              {helperText}
            </FormHelperText>
          )}
        </Box>
      )}
    </>
  )
}

export default LabelWithHelper
